import React, {useMemo, useState, useEffect} from 'react'
import {connect} from "react-redux";
import {update_to_cart} from "../../redux/actions/carrito";
import {toast} from 'react-toastify';
import ItemCartProduct from "../../widgets/item_cart_product";
import ButtonBack from "../../widgets/button_back";
import ButtonNext from "../../widgets/button_next";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {faCartShopping, faShieldHalved, faTruck, faTag} from "@fortawesome/free-solid-svg-icons";

function Part1({update_to_cart, carrito_redux, next, token}) {

    const [carrito, setCarrito] = useState(carrito_redux);

    useEffect(() => {
        update_to_cart(carrito)
    }, [carrito]);

    const subTotal = useMemo(() => {
        return carrito.reduce((acc, producto) => {
            let price = producto.price;
            if (producto.has_offer) {
                price = producto.offer_price;
            }
            return acc + price * producto.quantity;
        }, 0);
    }, [carrito]);

    const totalItems = useMemo(() => {
        return carrito.reduce((acc, p) => acc + p.quantity, 0);
    }, [carrito]);

    const disminuirProducto = (id) => {
        setCarrito((prevCarrito) =>
            prevCarrito.map((p) => p.variant_id === id ? {...p, quantity: p.quantity - 1} : p)
                .filter((p) => p.quantity > 0)
        );
    };
    const aumentarProducto = (id) => {
        let producto = carrito.find((p) => p.variant_id === id);
        let stock = producto.variants.find((p) => p.id === id).stock;
        setCarrito((prevCarrito) =>
            prevCarrito.map((p) => p.variant_id === id ? {...p, quantity: p.quantity < stock ? p.quantity + 1 : p.quantity} : p)
        );
    };
    const eliminarProducto = (id) => {
        setCarrito((prevCarrito) => prevCarrito.filter((p) => p.variant_id !== id));
    };


    const volver = () => {
        window.history.back();
    }
    const siguiente = () => {
        if (token) {
            if (carrito.length > 0) {
                next(2);
            } else {
                toast.warn("No se pudo continuar con la compra. Intenta de nuevo o agregue productos al carrito.", {
                    position: "top-right",
                    autoClose: 3000,
                    hideProgressBar: false,
                    closeOnClick: true,
                    pauseOnHover: true,
                    draggable: true,
                    progress: undefined,
                    theme: "light",
                });
            }

        } else {
            toast.warn("No se pudo continuar con la compra. Intenta de nuevo o inicie sesion.", {
                position: "top-right",
                autoClose: 3000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true,
                progress: undefined,
                theme: "light",
            });
        }

    }

    return (
        <>
            <main className="w-full min-h-screen bg-gray-50">
                <div className="container mx-auto px-3 md:px-6 py-6 md:py-8">
                    <div className="grid grid-cols-1 lg:grid-cols-3 gap-6 md:gap-8">

                        {/* Cart Items Column */}
                        <div className="lg:col-span-2">
                            <div className="bg-white rounded-2xl shadow-sm border border-gray-100 overflow-hidden">
                                {/* Header */}
                                <div className="px-5 md:px-6 pt-5 md:pt-6 pb-4 border-b border-gray-100">
                                    <div className="flex items-center justify-between">
                                        <div className="flex items-center gap-3">
                                            <div className="w-10 h-10 bg-blue-50 rounded-xl flex items-center justify-center">
                                                <FontAwesomeIcon icon={faCartShopping} className="text-ecoprimary1"/>
                                            </div>
                                            <div>
                                                <h2 className="text-xl font-bold text-gray-900">Mi Carrito</h2>
                                                <p className="text-sm text-gray-500">{totalItems} {totalItems === 1 ? 'producto' : 'productos'}</p>
                                            </div>
                                        </div>
                                        {carrito.length > 0 && (
                                            <span className="hidden sm:inline-flex items-center bg-ecoprimary1 text-white text-xs font-bold px-3 py-1.5 rounded-full">
                                                {carrito.length} {carrito.length === 1 ? 'ítem' : 'ítems'}
                                            </span>
                                        )}
                                    </div>
                                </div>

                                {/* Products List */}
                                {carrito.length > 0 ? (
                                    <div className="px-4 md:px-6 py-4 max-h-[60vh] md:max-h-[65vh] overflow-y-auto space-y-3 scrollbar-thin">
                                        {carrito.map((product, index) =>
                                            <ItemCartProduct
                                                eliminarProducto={eliminarProducto}
                                                disminuirProducto={disminuirProducto}
                                                aumentarProducto={aumentarProducto}
                                                product={product}
                                                key={index}
                                            />
                                        )}
                                    </div>
                                ) : (
                                    /* Empty State */
                                    <div className="px-6 py-16 text-center">
                                        <div className="w-20 h-20 bg-gray-100 rounded-full flex items-center justify-center mx-auto mb-4">
                                            <FontAwesomeIcon icon={faCartShopping} className="text-3xl text-gray-300"/>
                                        </div>
                                        <h3 className="text-lg font-bold text-gray-700 mb-2">Tu carrito está vacío</h3>
                                        <p className="text-sm text-gray-400 mb-6">Agrega productos para comenzar tu compra</p>
                                        <button
                                            onClick={volver}
                                            className="bg-ecoprimary1 text-white px-6 py-2.5 rounded-lg font-semibold text-sm hover:shadow-lg hover:shadow-blue-200 transition-all duration-300"
                                        >
                                            Explorar productos
                                        </button>
                                    </div>
                                )}

                                {/* Bottom action */}
                                {carrito.length > 0 && (
                                    <div className="px-5 md:px-6 py-4 border-t border-gray-100">
                                        <ButtonBack onClick={volver} label="← Seguir comprando"/>
                                    </div>
                                )}
                            </div>
                        </div>

                        {/* Summary Column */}
                        <div className="lg:col-span-1">
                            <div className="lg:sticky lg:top-24">
                                <div className="bg-white rounded-2xl shadow-sm border border-gray-100 overflow-hidden">
                                    <div className="px-5 md:px-6 pt-5 md:pt-6 pb-4 border-b border-gray-100">
                                        <h2 className="text-lg font-bold text-gray-900">Resumen del pedido</h2>
                                    </div>

                                    <div className="px-5 md:px-6 py-5">
                                        <div className="flex justify-between items-center py-3">
                                            <span className="text-sm text-gray-500">Subtotal ({totalItems} productos)</span>
                                            <span className="text-sm font-semibold text-gray-700">Bs {subTotal.toFixed(2)}</span>
                                        </div>
                                        <div className="flex justify-between items-center py-3 border-b border-gray-100">
                                            <span className="text-sm text-gray-500">Envío</span>
                                            <span className="text-sm font-medium text-gray-400">Coordinación interna</span>
                                        </div>

                                        <div className="flex justify-between items-center py-4">
                                            <span className="text-base font-bold text-gray-900">Total estimado</span>
                                            <span className="text-xl font-bold text-ecoprimary1">Bs {subTotal.toFixed(2)}</span>
                                        </div>

                                        <ButtonNext
                                            className="w-full mt-2"
                                            onClick={siguiente}
                                            label="Continuar →"
                                        />
                                    </div>

                                    {/* Trust badges */}
                                    <div className="px-5 md:px-6 pb-5 pt-2">
                                        <div className="flex flex-col gap-2">
                                            <div className="flex items-center gap-2 text-xs text-gray-400">
                                                <FontAwesomeIcon icon={faShieldHalved} className="text-green-500"/>
                                                <span>Compra segura</span>
                                            </div>
                                            <div className="flex items-center gap-2 text-xs text-gray-400">
                                                <FontAwesomeIcon icon={faTruck} className="text-ecoprimary1"/>
                                                <span>Envío a todo el país</span>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </main>
        </>
    );
}

const mapStateToProps = state => ({
    carrito_redux: state.Cart.carrito,
    token: state.Auth.token,
})

export default connect(mapStateToProps, {
    update_to_cart
})(Part1)